import { ISetPaginationPayload } from '../actions/pagination';
import {IApiQueryData, IProductReviewActionState} from '../interfaces';
import {PARAM_LANGUAGE, PARAM_PAGE} from '../constants';

export const doSetLanguages = (state: IProductReviewActionState, payload: ISetPaginationPayload): IProductReviewActionState => {
    const newApiQueryData: IApiQueryData = {
        ...state.apiQueryData,
        [PARAM_LANGUAGE]: [payload[PARAM_LANGUAGE]],
        [PARAM_PAGE]: '1',
    };

    return {
        ...state,
        productReviews: [],
        isPageLoading: true,
        apiQueryData: newApiQueryData,
    };
};
